import { GetRafCode } from '@staff-app/actions/meta-info.actions';
import { jobAppOpenStatusDTO } from '@staff-app/models/jobAppOpenStatusDTO';
import { jobAppProcessStatusDTO } from '@staff-app/models/jobAppProcessStatusDTO';
import { MetaInfoActions, MetaInfoActionTypes } from '@staff-app/actions/meta-info.actions';

export interface State {
  hasSeenIntro: boolean | null;
  rafCode: string | null;
  jobAppOpenStatus?: jobAppOpenStatusDTO | null;
  jobAppProcessStatus?: jobAppProcessStatusDTO | null;
  //isJobAppCompleted: boolean | null;
}

export const initialState: State = {
  hasSeenIntro: null,
  rafCode: null,
  jobAppOpenStatus: null,
  jobAppProcessStatus: null,
  //isJobAppCompleted: null
};

export function reducer(state = initialState, action: MetaInfoActions): State {
  switch (action.type) {
    case MetaInfoActionTypes.Continue: {
      return {
        ...state,
        hasSeenIntro: action.payload
      };
    }
    case MetaInfoActionTypes.GetRafCode: {
      return {
        ...state,
        rafCode: action.payload
      };
    }
    case MetaInfoActionTypes.GetJobAppOpenStatusInfoSuccessful: {
      return {
        ...state,
        jobAppOpenStatus: action.payload
      };
    }
    case MetaInfoActionTypes.GetJobAppProcessStatusInfoSuccessful: {
      return {
        ...state,
        jobAppProcessStatus: action.payload
      };
    }
    // case MetaInfoActionTypes.GetJobAppIsCompleteSuccessful: {
    //   return {
    //     ...state,
    //     isJobAppCompleted: action.payload
    //   };
    // }
    default: {
      return state;
    }
  }
}

export const getHasSeenIntro = (state: State) => state.hasSeenIntro;
export const getJobAppOpenStatus = (state: State) => state.jobAppOpenStatus;
export const getJobAppProcessStatus = (state: State) => state.jobAppProcessStatus;
export const getIsJobAppCompleted = (state: State) => state.jobAppProcessStatus?.isCompleted;
export const getIsJobAppEditable = (state: State) => state.jobAppProcessStatus?.isEditable;
export const getRafCode = (state: State) => state.rafCode;
